import {Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {BackOfficeAgentRequestSteps} from "./steps";
import {BackOfficeAgentRequestPersonalInfo} from "./agent_request_personal_info"
import {BackOfficeAgentRequestContactInfo} from "./agent_request_contact_info"
import {BackOfficeAgentRequestExpertInfo} from "./agent_request_expert_info"
import {BackOfficeAgentRequestFile} from "./agent_request_file"
import {roleSwitch} from "../../../services/user/login";
import authManager from "../../../helper/AuthHelper";
import SelectInput from "../../system/select";
import {getPersonsNameAndFamily} from "../../../services/profile/profile";
import {getBackOfficeUserAgentRequest} from "../../../services/back_office/agent";

export function BackOfficeAgentRequestManagement({changeComponent}) {

  const [personId, setPersonId] = useState(null);

  const [activeStep, setActiveStep] = useState(0);
  const [agentRequest, setAgentRequest] = useState();

  const [isLastStep, setIsLastStep] = useState(false);
  const [isFirstStep, setIsFirstStep] = useState(false);
  const [allowedStep, setAllowedStep] = useState(null);

  const [agentLog, setAgentLog] = useState("no_one");

  const handleNext = (step) => (setActiveStep(step));
  const handlePrev = (step) => (setActiveStep(step));

  useEffect(() => {
    async function getData(personId) {
      const result = await getBackOfficeUserAgentRequest(personId);
      if (result.status === 200) {
        const {agent_request, agent_log} = result.data;
        agent_request.person_id = personId;
        setAgentRequest(agent_request);
        setActiveStep((agent_request.step && agent_request.step) || 0);
        setAllowedStep((agent_request.step && agent_request.step) || 0);
        setAgentLog(agent_log)
      } else {
        setAgentRequest(null);
        setActiveStep(0);
        setAllowedStep(0);
      }
    }

    if (personId !== null) {

      getData(personId)
    }
  }, [personId]);

  useEffect(() => {
    setAgentLog(agentLog)
  }, [agentLog]);

  useEffect(() => {
    if (!agentRequest || !agentRequest.id) {
      setAllowedStep(0)
    } else {
      setAllowedStep(agentRequest.step)
    }
  }, [agentRequest])

  useEffect(() => {
    if (allowedStep <= activeStep) {
      setAllowedStep(activeStep)
    }
  }, [activeStep]);

  async function changeRole() {
    const data = {
      role_id: 2,
    };
    let result;

    result = await roleSwitch(data);

    if (result.status === 200) {
      // const {token, userInfo, expiration} = loginData;
      authManager.loginHandler(result.data)
      window.location.href = '/';
      localStorage.setItem("lastClicked", "agent_request")
    }
  }

  return (
    <div className="">
      <Card className="pt-8 overflow-y-visible min-h-screen">
        <CardHeader floated={true} shadow={false} className="min-h-fit shadow-xl px-4 overflow-y-visible">
          <div className="mb-8 flex items-center justify-between p-4">
            <Typography variant="h5" color="blue-gray">ایجاد مباشر</Typography>
          </div>

          <div className="flex flex-col mb-4 overflow-y-visible">
            <SelectInput
              label={"کاربر"}
              defaultValue={personId}
              refreshSignal={personId}
              // multiselect={false}
              autoLoadService={getPersonsNameAndFamily}
              autoLoadRender={({name, family, phone}) => {
                const fullName = `${name.trim()} ${family.trim()}`.trim()
                return fullName + " - " + phone
              }}
              onChange={setPersonId}
            />
          </div>

        </CardHeader>
        {agentRequest &&
          <CardBody className="overflow-x-auto w-full h-full overflow-y-visible">
            <div className="mb-40">
              <BackOfficeAgentRequestSteps
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                isLastStep={isLastStep}
                setIsLastStep={setIsLastStep}
                isFirstStep={isFirstStep}
                setIsFirstStep={setIsFirstStep}
                handleNext={handleNext}
                handlePrev={handlePrev}
                allowedStep={allowedStep}
              />
            </div>
            <div className="mt-20">
              {activeStep === 0 &&
                <BackOfficeAgentRequestPersonalInfo
                  activeStep={activeStep}
                  setActiveStep={setActiveStep}
                  agentRequest={agentRequest}
                  setAgentRequest={setAgentRequest}
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                  isLastStep={isLastStep}
                  isFirstStep={isFirstStep}
                  allowedStep={allowedStep}
                  setAllowedStep={setAllowedStep}
                  person_id={personId}
                />}
              {activeStep === 1 && <BackOfficeAgentRequestContactInfo
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                agentRequest={agentRequest}
                setAgentRequest={setAgentRequest}
                handleNext={handleNext}
                handlePrev={handlePrev}
                isLastStep={isLastStep}
                isFirstStep={isFirstStep}
                allowedStep={allowedStep}
                setAllowedStep={setAllowedStep}
                person_id={personId}
              />}
              {activeStep === 2 && <BackOfficeAgentRequestExpertInfo
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                agentRequest={agentRequest}
                setAgentRequest={setAgentRequest}
                handleNext={handleNext}
                handlePrev={handlePrev}
                isLastStep={isLastStep}
                isFirstStep={isFirstStep}
                allowedStep={allowedStep}
                setAllowedStep={setAllowedStep}
                person_id={personId}
              />}
              {activeStep === 3 && <BackOfficeAgentRequestFile
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                agentRequest={agentRequest}
                setAgentRequest={setAgentRequest}
                handleNext={handleNext}
                handlePrev={handlePrev}
                isLastStep={isLastStep}
                isFirstStep={isFirstStep}
                agentLog={agentLog}
                setAgentLog={setAgentLog}
                person_id={personId}
              />}
            </div>

          </CardBody>
        }
      </Card>
    </div>
  );
}